
import AsyncStorage from '@react-native-async-storage/async-storage';
import { API } from '../../utils';

/**
 * Sends a product request to the API
 * @param {Object} payload - Product details
 * @param {string} payload.manufacturer
 * @param {string} payload.productName
 * @param {string} payload.url
 * @param {string} payload.description
 * @param {number|string} payload.user_id
 * @returns {Promise<Object>} - API response
 */
/**
 * Sends a product request to the API
 * @param {Object} payload - Product details (without user_id)
 * @returns {Promise<Object>} - API response
 */
export const sendProductRequest = async (payload) => {
  try {
    // Get token & user_id from AsyncStorage
    const token = await AsyncStorage.getItem('key');
    const user_id = await AsyncStorage.getItem('id');

    if (!user_id) {
      throw new Error('User ID not found in AsyncStorage');
    }

    // Merge payload with user_id
    const body = JSON.stringify({
      ...payload,
      user_id: Number(user_id),
    });

    const response = await fetch(`${API.baseurl}${API.AddProductRequest}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log('sendProductRequest Response:', data);
    return data;
  } catch (error) {
    console.error('Error in sendProductRequest:', error);
    throw error;
  }
};


/**
 * Get all messages for a specific product
 * @param {number|string} product_id - ID of the product
 * @returns {Promise<Object>} - API response with product and messages
 */
export const getProductMessages = async (product_id) => {
  try {
    if (!product_id) throw new Error('Product ID is required');

    const response = await fetch(`${API.baseurl}${API.GetProductWithMessages}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ product_id }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log('getProductMessages Response:', data);
    return data;
  } catch (error) {
    console.error('Error in getProductMessages:', error);
    throw error;
  }
};

/**
 * Send a message for a product request
 * @param {Object} payload
 * @param {number|string} payload.product_id
 * @param {string} payload.message
 * @param {number|string|null} [payload.admin_id] - optional
 * @param {number|string|null} [payload.user_id] - optional
 * @returns {Promise<Object>} - API response
 */
export const createMessage = async (payload) => {
  try {
    // Get user_id from AsyncStorage if not provided
    if (!payload.user_id) {
      const user_id = await AsyncStorage.getItem('id');
      if (!user_id) throw new Error('User ID not found in AsyncStorage');
      payload.user_id = Number(user_id);
    }

    const response = await fetch(`${API.baseurl}${API   .CreateMessage}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log('createMessage Response:', data);
    return data;
  } catch (error) {
    console.error('Error in createMessage:', error);
    throw error;
  }
};